<div class="main-container">
  <div class="header">
    <h1>{{ 'genericTree.title' | transloco }}</h1>
  </div>

  <div class="filters-container">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'genericTree.consumer' | transloco }}</mat-label>
      <mat-select [value]="selectedConsumerId()" (selectionChange)="onConsumerChange($event.value)">
        @for (consumer of consumers$ | async; track consumer.id) {
        <mat-option [value]="consumer.id">
          {{ consumer.name }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'genericTree.subject' | transloco }}</mat-label>
      <mat-select [value]="selectedSubjectId()" (selectionChange)="onSubjectChange($event.value)">
        @for (subject of subjects$ | async; track subject.id) {
        <mat-option [value]="subject.id">
          {{ subject.name }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <button mat-raised-button color="primary" (click)="addRootNode()" [disabled]="!selectedConsumerId() || !selectedSubjectId()">
      <mat-icon>add</mat-icon> {{ 'genericTree.addRootNode' | transloco }}
    </button>

    @if (isAdmin()) {
      <button mat-raised-button color="primary" (click)="assignMetadataByLevel()" [disabled]="isAssignMetadataDisabled()">
        <mat-icon>assignment</mat-icon> {{ 'genericTree.action.assignMetadata' | transloco }}
      </button>
    }
  </div>

  @if (selectedConsumerId() && selectedSubjectId()) {
  <div class="tree-container">
    <div class="drag-drop-hint">
      <mat-icon>info</mat-icon>
      <span>{{ 'genericTree.dragDropHint' | transloco }}</span>
    </div>
    <pixl-generic-tree-editor
      [consumerId]="selectedConsumerId()!"
      [subjectId]="selectedSubjectId()!">
    </pixl-generic-tree-editor>
  </div>
  } @else {
  <div class="prompt">
    <p>{{ 'genericTree.selectPrompt' | transloco }}</p>
  </div>
  }
</div>
